import React, { createContext, useContext, useState, useRef, useEffect, useCallback } from 'react';

const MusicPlayerContext = createContext();

// All character songs
const ALL_SONGS = {
  mena: [
    { id: 'mena-1', title: 'Rewrite the Flame', subtitle: 'Roe v. Wade', artist: 'Mena ORB', url: 'https://customer-assets.emergentagent.com/job_the-uplift/artifacts/epcwo6te_Rewrite%20the%20Flame%20%28Roe%20v.%20Wade%29%20-%20By%20Mena%20ORB.mp3' },
    { id: 'mena-2', title: 'Ignite', subtitle: "Democracy's Heartbeat", artist: 'Mena ORB', url: 'https://customer-assets.emergentagent.com/job_the-uplift/artifacts/41y7p6q8_Ignite%20%28Democracy%27s%20Heatbeat%29%20-%20By%20Mena%20ORB.mp3' },
    { id: 'mena-3', title: 'A Rigged System', subtitle: '', artist: 'Mena ORB', url: 'https://customer-assets.emergentagent.com/job_the-uplift/artifacts/ys7tdhxt_A%20Rigged%20System%20-%20By%20Mena%20ORB.mp3' },
    { id: 'mena-4', title: 'Shadows', subtitle: 'Israel & Gaza', artist: 'Mena ORB', url: 'https://customer-assets.emergentagent.com/job_the-uplift/artifacts/iie5mhyj_Shadows_%20Israel%20%26%20Gaza%20-%20By%20Mena%20ORB.mp3' },
    { id: 'mena-5', title: 'Join the Movement', subtitle: '', artist: 'Mena ORB', url: 'https://customer-assets.emergentagent.com/job_the-uplift/artifacts/aibxd7np_Join%20the%20Movement%20-%20Mena%20ORB.mp3' },
  ],
  katie: [
    { id: 'katie-1', title: 'Plant the Seeds', subtitle: '', artist: 'Katie ORB', url: 'https://customer-assets.emergentagent.com/job_the-uplift/artifacts/b5y5izng_Plant%20the%20Seeds%20-%20By%20Katie%20Orb.mp3' },
    { id: 'katie-2', title: 'Download ORB', subtitle: '', artist: 'Katie ORB', url: 'https://customer-assets.emergentagent.com/job_the-uplift/artifacts/rpv0xogs_Download%20ORB%20by%20Katie%20Orb.mp3' },
    { id: 'katie-3', title: 'Teacher Teacher', subtitle: '', artist: 'Katie ORB', url: 'https://customer-assets.emergentagent.com/job_the-uplift/artifacts/bqi3up5k_Teacher%20Teacher%20-%20By%20Katie%20Orb.mp3' },
    { id: 'katie-4', title: 'Freedom & Truth', subtitle: '', artist: 'Katie ORB', url: 'https://customer-assets.emergentagent.com/job_the-uplift/artifacts/jl5b17eg_Freedom%20%26%20Truth%20-%20By%20Katie%20Orb.mp3' },
    { id: 'katie-5', title: 'Reclaim Your Voice', subtitle: 'ft. Mena ORB', artist: 'Katie ORB', url: 'https://customer-assets.emergentagent.com/job_the-uplift/artifacts/lbdgyoyl_Reclaim%20Your%20Voice%20by%20Katie%20ORB%20%28ft.%20Mena%20ORB%29.mp3' },
  ],
  dorian: [
    { id: 'dorian-1', title: 'Join the Movement', subtitle: '', artist: 'Dorian ORB', url: 'https://customer-assets.emergentagent.com/job_the-uplift/artifacts/ijbiy4eo_Join%20the%20Movement.mp3' },
    { id: 'dorian-2', title: "Justice Ain't Equal", subtitle: '', artist: 'Dorian ORB', url: 'https://customer-assets.emergentagent.com/job_the-uplift/artifacts/gdd2zjw3_Justice%20Ain%27t%20Equal%20%281%29.mp3' },
    { id: 'dorian-3', title: 'The World on Fire', subtitle: '', artist: 'Dorian ORB', url: 'https://customer-assets.emergentagent.com/job_the-uplift/artifacts/5vs1psqp_The%20World%20on%20Fire%20-%20By%20Dorian%20Orb.mp3' },
    { id: 'dorian-4', title: 'The Chalkboard Blues', subtitle: '', artist: 'Dorian ORB', url: 'https://customer-assets.emergentagent.com/job_the-uplift/artifacts/nsq0djdo_The%20Chalkboard%20Blues%20-%20By%20Dorian%20Orb.mp3' },
    { id: 'dorian-5', title: 'Pills and Bills', subtitle: '', artist: 'Dorian ORB', url: 'https://customer-assets.emergentagent.com/job_the-uplift/artifacts/ws51dm73_Pills%20and%20Bills%20-%20By%20Dorian%20Orb%20%281%29.mp3' },
  ],
  octavio: [
    { id: 'octavio-1', title: 'The Border', subtitle: '', artist: 'Octavio ORB', url: 'https://customer-assets.emergentagent.com/job_the-uplift/artifacts/6eko1xmp_The%20Border%20-%20By%20Octavio%20Orb.mp3' },
    { id: 'octavio-2', title: 'Unbalanced', subtitle: '', artist: 'Octavio ORB', url: 'https://customer-assets.emergentagent.com/job_the-uplift/artifacts/4q45omlz_Unbalanced%20-%20By%20Octavio%20ORB.mp3' },
    { id: 'octavio-3', title: 'Download ORB', subtitle: '', artist: 'Octavio ORB', url: 'https://customer-assets.emergentagent.com/job_the-uplift/artifacts/bjj9j7e3_Download%20ORB.mp3' },
    { id: 'octavio-4', title: 'Lonely Lone Star', subtitle: '', artist: 'Octavio ORB', url: 'https://customer-assets.emergentagent.com/job_the-uplift/artifacts/w5f23gbx_Lonely%20Lone%20Star.mp3' },
    { id: 'octavio-5', title: 'Fuego del Destino', subtitle: '', artist: 'Octavio ORB', url: 'https://customer-assets.emergentagent.com/job_the-uplift/artifacts/xwjrd3s2_Fuego%20del%20Destino.mp3' },
  ],
};

// Character colors
const CHARACTER_COLORS = {
  mena: '#8B5CF6',
  katie: '#EC4899',
  dorian: '#F59E0B',
  luke: '#3B82F6',
  octavio: '#10B981',
  orb: '#586D52',
};

// Character artwork (used for iOS lock-screen / MediaSession metadata)
const CHARACTER_ARTWORK = {
  mena: 'https://customer-assets.emergentagent.com/job_orb-management-app/artifacts/67lqvc7a_Mena%20Standard.png',
  katie: 'https://customer-assets.emergentagent.com/job_orb-management-app/artifacts/b90ayuat_katie%20standard.png',
  luke: 'https://customer-assets.emergentagent.com/job_orb-management-app/artifacts/ue5pv5dv_Luke%20Standard.png',
  dorian: 'https://customer-assets.emergentagent.com/job_orb-management-app/artifacts/bi6kcptf_Dorian%20Standard.png',
  octavio: 'https://customer-assets.emergentagent.com/job_orb-management-app/artifacts/zi3ibx7q_Octavio%20Standard.png',
};

export const MusicPlayerProvider = ({ children }) => {
  const audioRef = useRef(null);
  const [currentSong, setCurrentSong] = useState(null);
  const [currentCharacter, setCurrentCharacter] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [playlist, setPlaylist] = useState([]);
  const [isInputFocused, setIsInputFocused] = useState(false);
  
  // Refs to track current values for the ended handler
  const currentSongRef = useRef(currentSong);
  const playlistRef = useRef(playlist);
  
  // Keep refs in sync with state
  useEffect(() => {
    currentSongRef.current = currentSong;
  }, [currentSong]);
  
  useEffect(() => {
    playlistRef.current = playlist;
  }, [playlist]);

  // Initialize audio element
  useEffect(() => {
    if (!audioRef.current) {
      audioRef.current = new Audio();
      audioRef.current.preload = 'auto';  // Load full audio for accurate duration
    }

    const audio = audioRef.current;

    const handleTimeUpdate = () => {
      setCurrentTime(audio.currentTime);
      // Also try to get duration if it wasn't set by loadedmetadata
      if (audio.duration && !isNaN(audio.duration) && audio.duration !== Infinity) {
        setDuration(audio.duration);
      }
    };

    const handleLoadedMetadata = () => {
      if (audio.duration && !isNaN(audio.duration) && audio.duration !== Infinity) {
        setDuration(audio.duration);
      }
    };

    const handleDurationChange = () => {
      if (audio.duration && !isNaN(audio.duration) && audio.duration !== Infinity) {
        setDuration(audio.duration);
      }
    };

    const handleCanPlay = () => {
      // Another opportunity to get duration
      if (audio.duration && !isNaN(audio.duration) && audio.duration !== Infinity) {
        setDuration(audio.duration);
      }
    };

    const handleEnded = () => {
      // Use refs to get current values
      const song = currentSongRef.current;
      const list = playlistRef.current;
      
      // Check if current song is a recording (not from playlist)
      if (song?.id?.startsWith('recording-') || list.length === 0) {
        // For recordings or songs without a playlist, stop playback
        setIsPlaying(false);
        setCurrentTime(0);
        return;
      }
      
      // Auto-play next song for music
      const currentIndex = list.findIndex(s => s.id === song?.id);
      if (currentIndex !== -1 && list.length > 0) {
        const nextIndex = (currentIndex + 1) % list.length;
        const nextSong = list[nextIndex];
        
        // Reset state and play next song
        setDuration(0);
        setCurrentTime(0);
        setCurrentSong(nextSong);
        
        audio.src = nextSong.url;
        audio.currentTime = 0;
        audio.load();
        audio.play().catch(err => console.error('Auto-play next failed:', err));
      }
    };

    const handlePlay = () => setIsPlaying(true);
    const handlePause = () => setIsPlaying(false);

    audio.addEventListener('timeupdate', handleTimeUpdate);
    audio.addEventListener('loadedmetadata', handleLoadedMetadata);
    audio.addEventListener('durationchange', handleDurationChange);
    audio.addEventListener('canplay', handleCanPlay);
    audio.addEventListener('ended', handleEnded);
    audio.addEventListener('play', handlePlay);
    audio.addEventListener('pause', handlePause);

    return () => {
      audio.removeEventListener('timeupdate', handleTimeUpdate);
      audio.removeEventListener('loadedmetadata', handleLoadedMetadata);
      audio.removeEventListener('durationchange', handleDurationChange);
      audio.removeEventListener('canplay', handleCanPlay);
      audio.removeEventListener('ended', handleEnded);
      audio.removeEventListener('play', handlePlay);
      audio.removeEventListener('pause', handlePause);
    };
  }, []);

  const playSong = useCallback((song, characterId) => {
    const audio = audioRef.current;
    if (!audio) return;

    // If same song, toggle play/pause
    if (currentSong?.id === song.id) {
      if (isPlaying) {
        audio.pause();
      } else {
        audio.play();
      }
      return;
    }

    // New song - reset state and load
    setDuration(0);
    setCurrentTime(0);
    setCurrentSong(song);
    setCurrentCharacter(characterId);
    setPlaylist(ALL_SONGS[characterId] || []);
    
    // Load and play new audio - reset position first
    audio.pause(); // Stop any current playback
    audio.currentTime = 0; // Reset position
    audio.src = song.url;
    audio.load(); // Explicitly load to trigger metadata events
    audio.play().catch(err => console.error('Play failed:', err));
  }, [currentSong, isPlaying]);

  const togglePlayPause = useCallback(() => {
    const audio = audioRef.current;
    if (!audio || !currentSong) return;

    if (isPlaying) {
      audio.pause();
    } else {
      audio.play();
    }
  }, [currentSong, isPlaying]);

  const playNext = useCallback(() => {
    if (!currentSong || playlist.length === 0) return;
    
    const currentIndex = playlist.findIndex(s => s.id === currentSong.id);
    const nextIndex = (currentIndex + 1) % playlist.length;
    const nextSong = playlist[nextIndex];
    
    const audio = audioRef.current;
    if (audio) {
      audio.src = nextSong.url;
      audio.play();
      setCurrentSong(nextSong);
    }
  }, [currentSong, playlist]);

  const playPrevious = useCallback(() => {
    if (!currentSong || playlist.length === 0) return;
    
    const currentIndex = playlist.findIndex(s => s.id === currentSong.id);
    const prevIndex = currentIndex === 0 ? playlist.length - 1 : currentIndex - 1;
    const prevSong = playlist[prevIndex];
    
    const audio = audioRef.current;
    if (audio) {
      audio.src = prevSong.url;
      audio.play();
      setCurrentSong(prevSong);
    }
  }, [currentSong, playlist]);

  const seekForward = useCallback(() => {
    const audio = audioRef.current;
    if (audio) {
      audio.currentTime = Math.min(audio.currentTime + 10, audio.duration);
    }
  }, []);

  const seekBackward = useCallback(() => {
    const audio = audioRef.current;
    if (audio) {
      audio.currentTime = Math.max(audio.currentTime - 10, 0);
    }
  }, []);

  const stopPlayback = useCallback(() => {
    const audio = audioRef.current;
    if (audio) {
      audio.pause();
      audio.currentTime = 0;
    }
    setCurrentSong(null);
    setCurrentCharacter(null);
    setIsPlaying(false);
  }, []);

  const getCharacterColor = useCallback(() => {
    return CHARACTER_COLORS[currentCharacter] || '#586D52';
  }, [currentCharacter]);

  const timeRemaining = (duration && isFinite(duration) && duration > 0) 
    ? Math.max(0, duration - currentTime) 
    : 0;

  // ===== MediaSession API =====
  // Surfaces song metadata + transport controls on the iOS/Android lock screen
  // and in Control Center / system media widgets while the phone is asleep.
  useEffect(() => {
    if (typeof navigator === 'undefined' || !('mediaSession' in navigator)) return;
    if (!currentSong) {
      try { navigator.mediaSession.metadata = null; } catch (e) {}
      try { navigator.mediaSession.playbackState = 'none'; } catch (e) {}
      return;
    }
    const artwork = currentSong.artwork || CHARACTER_ARTWORK[currentCharacter];
    try {
      navigator.mediaSession.metadata = new window.MediaMetadata({
        title: currentSong.title || 'Untitled',
        artist: currentSong.artist || (currentCharacter ? `${currentCharacter.charAt(0).toUpperCase()}${currentCharacter.slice(1)} ORB` : 'The Uplift'),
        album: currentSong.subtitle || 'The Uplift',
        artwork: artwork ? [
          { src: artwork, sizes: '96x96',   type: 'image/png' },
          { src: artwork, sizes: '192x192', type: 'image/png' },
          { src: artwork, sizes: '256x256', type: 'image/png' },
          { src: artwork, sizes: '384x384', type: 'image/png' },
          { src: artwork, sizes: '512x512', type: 'image/png' },
        ] : [],
      });
    } catch (e) { /* MediaMetadata may not be available */ }
  }, [currentSong, currentCharacter]);

  // Reflect playback state for the lock-screen widget
  useEffect(() => {
    if (typeof navigator === 'undefined' || !('mediaSession' in navigator)) return;
    try {
      navigator.mediaSession.playbackState = isPlaying ? 'playing' : 'paused';
    } catch (e) {}
  }, [isPlaying]);

  // Wire up Control Center / lock-screen transport controls
  useEffect(() => {
    if (typeof navigator === 'undefined' || !('mediaSession' in navigator)) return;
    const ms = navigator.mediaSession;
    const safeSet = (action, handler) => {
      try { ms.setActionHandler(action, handler); } catch (e) {}
    };
    safeSet('play',           () => togglePlayPause());
    safeSet('pause',          () => togglePlayPause());
    safeSet('previoustrack',  () => playPrevious());
    safeSet('nexttrack',      () => playNext());
    safeSet('seekbackward',   () => seekBackward());
    safeSet('seekforward',    () => seekForward());
    return () => {
      ['play','pause','previoustrack','nexttrack','seekbackward','seekforward'].forEach((a) => safeSet(a, null));
    };
  }, [togglePlayPause, playPrevious, playNext, seekBackward, seekForward]);

  // Keep the lock-screen scrubber accurate
  useEffect(() => {
    if (typeof navigator === 'undefined' || !('mediaSession' in navigator)) return;
    if (!('setPositionState' in navigator.mediaSession)) return;
    if (!duration || !isFinite(duration) || duration <= 0) return;
    try {
      navigator.mediaSession.setPositionState({
        duration,
        position: Math.min(currentTime, duration),
        playbackRate: 1,
      });
    } catch (e) {}
  }, [currentTime, duration]);

  return (
    <MusicPlayerContext.Provider value={{
      currentSong,
      currentCharacter,
      isPlaying,
      currentTime,
      duration,
      timeRemaining,
      playlist,
      playSong,
      togglePlayPause,
      playNext,
      playPrevious,
      seekForward,
      seekBackward,
      stopPlayback,
      getCharacterColor,
      getAllSongs: () => ALL_SONGS,
      getCharacterSongs: (charId) => ALL_SONGS[charId] || [],
      isInputFocused,
      setIsInputFocused,
    }}>
      {children}
    </MusicPlayerContext.Provider>
  );
};

export const useMusicPlayer = () => {
  const context = useContext(MusicPlayerContext);
  if (!context) {
    throw new Error('useMusicPlayer must be used within MusicPlayerProvider');
  }
  return context;
};

export default MusicPlayerContext;
